/* ============================================================
   FlickerBet — Contact / Demo Form
   POST /api/contactus
   ============================================================ */
(function () {
  'use strict';

  const form      = document.getElementById('contact-form');
  const submitBtn = document.getElementById('form-submit');
  const msgOut    = document.getElementById('form-message-output');

  if (!form || !submitBtn || !msgOut) return;

  function showMessage(text, type) {
    msgOut.textContent = text;
    msgOut.className = type; // 'success' | 'error'
  }

  function clearMessage() {
    msgOut.textContent = '';
    msgOut.className = '';
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    clearMessage();

    const name    = (form.querySelector('#form-name')    ?.value || '').trim();
    const email   = (form.querySelector('#form-email')   ?.value || '').trim();
    const phone   = (form.querySelector('#form-phone')   ?.value || '').trim();
    const company = (form.querySelector('#form-company') ?.value || '').trim();
    const message = (form.querySelector('#form-message') ?.value || '').trim();

    // Validation
    if (!phone) {
      showMessage('Please enter your phone number or WhatsApp.', 'error');
      form.querySelector('#form-phone')?.focus();
      return;
    }

    if (!message) {
      showMessage('Please tell us a little about your platform.', 'error');
      form.querySelector('#form-message')?.focus();
      return;
    }

    // Disable submit
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    const body = { phone, message };
    if (name)    body.name    = name;
    if (email)   body.email   = email;
    if (company) body.message = message + (company ? '\n\nCompany: ' + company : '');

    try {
      const response = await fetch('/api/contactus', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        showMessage('✅ Thanks! We\'ll be in touch within one business day to schedule your demo.', 'success');
        form.reset();
      } else {
        showMessage('Something went wrong. Please try again or email us directly.', 'error');
      }
    } catch (err) {
      showMessage('Unable to send your request. Please check your connection and try again.', 'error');
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Book My Demo →';
    }
  });
})();
